<!--
Hide breadcrumbs if only contains single item e.g. Start
Suggestion from Chiltern Oct 2019
-->
<ng-container *ngIf="navigation.breadcrumbs && navigation.breadcrumbs.length !== 1">

  <nav class="govuk-breadcrumbs noprint" *ngIf="navigation.breadcrumbs.length; else back">
    <ol class="govuk-breadcrumbs__list">

      <ng-container *ngFor="let crumb of navigation.breadcrumbs; last as isLast">

        <li class="govuk-breadcrumbs__list-item" *ngIf="!isLast else currentPage">
          <a *ngIf="crumb.route" class="govuk-breadcrumbs__link" [routerLink]="crumb.route">{{crumb.title}}</a>
          <a *ngIf="crumb.href" class="govuk-breadcrumbs__link" [href]="crumb.href" >{{crumb.title}}</a>
          <ng-container *ngIf="!crumb.href && !crumb.route">{{crumb.title}}</ng-container>
        </li>

        <ng-template #currentPage>
          <li class="govuk-breadcrumbs__list-item" aria-current="step">
            {{crumb.title}}
          </li>
        </ng-template>

      </ng-container>
    </ol>
    <!-- div class="sub-page" aria-live="assertive">{{navigation.subPage}}</div>-->

    <!-- 25/08/2019 removed following Shropshire accessibility report -->
    <!-- <div class="sub-page">{{navigation.subPage}}</div>-->
  </nav>

  <ng-template #back>
    <nav>
      <a (click)="navigation.back()" href='#' class="govuk-back-link noprint">Back</a>
    </nav>
  </ng-template>

</ng-container>

